import { Dispatcher } from 'flux'

/**
 * Represents an action
 */
export interface IAction {
    actionType: string
}

/**
 * Represents an action carrying a typed payload
 */
export interface IActionPayload<T> extends IAction {
    payload: T
}

class AppDispatcher<T> extends Dispatcher<T> {
    /**
     * Overloads the Flux Dispatcher.
     *
     * Will wait until the dispatcher is not dispatching before dispatching
     * a new action.
     *
     * Used as some views subscribe to store change events which cause actions to be dispatched.
     * However as the stores changed in repsonse to an action the dispatcher is still dispatching.
     *
     * This prevents that invalid state from occuring and still preserved the one way flow of state.
     * @param payload Action to be dispatched
     */
    dispatch(payload: T) {
        if (!this.isDispatching()) super.dispatch(payload)
        else
            this.waitUntilNotDispatching().then(() => {
                super.dispatch(payload)
            })
    }

    /**
     * Returns a promise which will loop until isDispatching is false.
     * Then will return true.
     */
    private waitUntilNotDispatching(): Promise<boolean> {
        return new Promise(async (resolve) => {
            while (this.isDispatching()) {
                await new Promise((resolve) => setTimeout(resolve, 10))
            }
            resolve(true)
        })
    }
}

export default new AppDispatcher<IAction>()
